import React from "react";
import Container from "./Container.jsx";

const Footer = (props) => {
    return (
        <Container name="footer">
            <Container name="left-side">
                <img
                    style={{ cursor: "pointer" }}
                    src="/assets/img/index/footer-logo.png"
                    alt="ArtCloud"
                    width="181px"
                    height="29px"
                />
                <Container name="social-media-icons">
                    <a href="https://instagram.com/artcloud" target="_blank">
                        <img
                            src="/assets/img/index/instagram_icon_1x.webp"
                            alt="Instagram"
                            height={30}
                        />
                    </a>
                    <a
                        href="https://www.linkedin.com/company/artcloud"
                        target="_blank"
                    >
                        <img
                            src="/assets/img/index/linked_icons_1x.webp"
                            alt="LinkedIn"
                            height={30}
                        />
                    </a>
                    <a
                        href="https://www.youtube.com/channel/UCp4VKbcR9AZwIfLREuuiF9Q"
                        target="_blank"
                    >
                        <img
                            src="/assets/img/index/youtube_icon_1x.webp"
                            alt="YouTube"
                            height={30}
                        />
                    </a>
                </Container>
                <Container name="brand-info">
                    <div>© {new Date().getFullYear()} ArtCloud</div>
                    <a href="https://artcloud.com/terms">Terms of Use</a>
                    <a href="https://artcloud.com/privacy">Privacy Policy</a>
                </Container>
            </Container>
            <Container name="sitemap">
                <Container contentClassNames="sitemap-column">
                    <div>My ArtCloud</div>
                    <a href="/register">
                        <span>+</span>Try for Free
                    </a>
                    <a href="/login">
                        <span>+</span>Login
                    </a>
                    <a
                        target="_blank"
                        href="https://help.artcloud.com/knowledge"
                    >
                        <span>+</span>Support
                    </a>
                </Container>
                <Container contentClassNames="sitemap-column">
                    <div>Learn More</div>
                    <a href="/manager-for-galleries">
                        <span>+</span>For Galleries
                    </a>
                    <a href="/manager-for-artists">
                        <span>+</span>For Artists
                    </a>
                    <a href="https://blog.artcloud.com" target="_blank">
                        <span>+</span>Blog
                    </a>
                </Container>
                <Container contentClassNames="sitemap-column">
                    <div>About</div>
                    <a href="/about#team">
                        <span>+</span>Our Team
                    </a>
                    <a href="/about#jobs">
                        <span>+</span>Careers
                    </a>
                    <a href="/about#contact">
                        <span>+</span>Contact
                    </a>
                </Container>
                <Container contentClassNames="sitemap-column">
                    <div>Marketplace</div>
                    <a href="https://artcloud.market/browse" target="_blank">
                        <span>+</span>Artworks
                    </a>
                    <a href="https://artcloud.market/galleries" target="_blank">
                        <span>+</span>Galleries
                    </a>
                    <a href="https://artcloud.market/artists" target="_blank">
                        <span>+</span>Artists
                    </a>
                    <a href="https://artcloud.market/jewelry" target="_blank">
                        <span>+</span>Jewelry
                    </a>
                </Container>
            </Container>
        </Container>
    );
};

export default Footer;
